import React from "react";
import { motion } from "framer-motion";

const VALUES = [
    {
        n: "01",
        title: "Multidisciplinaires",
        desc: "Un seul partenaire pour la photo, la vidéo, le web et la marque.",
    },
    {
        n: "02",
        title: "À taille humaine",
        desc: "Une relation directe avec les créatifs, sans intermédiaires inutiles.",
    },
    {
        n: "03",
        title: "Stratégie d'abord",
        desc: "Notre background marketing nourrit chaque décision visuelle.",
    },
    {
        n: "04",
        title: "Locaux, ambitieux",
        desc: "Nous élevons les petites entreprises avec des standards de grandes marques.",
    },
];

export default function About() {
    return (
        <section
            id="approche"
            data-testid="about-section"
            className="relative py-24 md:py-32 px-6 md:px-12 lg:px-16 border-t border-scd"
        >
            <div className="grid lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5">
                    <motion.div
                        initial={{ y: 40, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7 }}
                    >
                        <span className="label-eyebrow text-yellow">— Notre approche</span>
                        <h2
                            className="section-heading text-cream mt-6"
                            data-testid="about-heading"
                        >
                            Petites entreprises,
                            <br />
                            <span className="text-yellow italic">grandes ambitions.</span>
                        </h2>
                    </motion.div>
                </div>
                <div className="lg:col-span-7">
                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                        className="text-cream/85 text-lg md:text-xl leading-relaxed"
                    >
                        Studio Cent Douze est né d'une conviction simple&nbsp;: les
                        meilleures idées ne viennent pas toujours des plus grandes
                        agences. Avec un parcours en marketing, photographie, vidéo
                        et design graphique, nous avons rassemblé toutes les
                        disciplines visuelles sous un même toit pour offrir aux
                        petites entreprises des outils dignes des grandes marques.
                    </motion.p>
                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                        className="text-cream/70 text-base md:text-lg mt-6"
                    >
                        Chaque projet est traité comme une signature&nbsp;: une image
                        forte, cohérente et durable, capable d'élever votre
                        entreprise au-delà des attentes.
                    </motion.p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">
                        {VALUES.map((v, i) => (
                            <motion.div
                                key={v.n}
                                initial={{ y: 40, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.6, delay: 0.1 + i * 0.07 }}
                                data-testid={`value-card-${v.n}`}
                                className="border-t border-scd pt-5"
                            >
                                <span className="label-eyebrow text-yellow">{v.n}</span>
                                <h3 className="font-display text-2xl text-cream mt-2">
                                    {v.title}
                                </h3>
                                <p className="text-cream/70 mt-2 text-sm">{v.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
